/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type CampaignAccessType = typeof CampaignAccessType[keyof typeof CampaignAccessType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignAccessType = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
} as const;
